<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>Unidad principal de la estructura organizativa. Representa una razón social distinta con información
                fiscal y legal propia. Se debe crear una nueva compañía cuando se trata de una entidad financiera o
                legal diferente dentro del ecosistema AVE.</p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Configuración
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina los <b>materiales</b> configurados en las <b>políticas comerciales</b>.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Cnf. Listas</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'" (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>
          
            <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo Registro">
              <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
            </button>
            <div style="display:inline-flex">
              <button mat-icon-button [matMenuTriggerFor]="importMenu" matTooltip="Importar archivo">
                <mat-icon>
                  <!--Sin color
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256">
                    <g fill="#4f46e5" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M16,4c-1.65,0 -3,1.35 -3,3v4h2v-4c0,-0.55 0.45,-1 1,-1h14v8h-3.49023c0.29,0.61 0.46047,1.28 0.48047,2h3.00977v8h-3v2h3v8h-3.00977c-0.02,0.72 -0.19047,1.39 -0.48047,2h3.49023v8h-14c-0.55,0 -1,-0.45 -1,-1v-4h-2v4c0,1.65 1.35,3 3,3h30c1.65,0 3,-1.35 3,-3v-36c0,-1.65 -1.35,-3 -3,-3zM32,6h14c0.55,0 1,0.45 1,1v7h-15zM4.19922,13c-1.75547,0 -3.19922,1.44375 -3.19922,3.19922v17.60156c0,1.75547 1.44375,3.19922 3.19922,3.19922h17.60156c1.75547,0 3.19922,-1.44375 3.19922,-3.19922v-17.60156c0,-1.75547 -1.44375,-3.19922 -3.19922,-3.19922zM4.19922,15h17.60156c0.67453,0 1.19922,0.52468 1.19922,1.19922v17.60156c0,0.67453 -0.52469,1.19922 -1.19922,1.19922h-17.60156c-0.67453,0 -1.19922,-0.52468 -1.19922,-1.19922v-17.60156c0,-0.67453 0.52469,-1.19922 1.19922,-1.19922zM32,16h15v8h-15zM7.96875,19l3.49414,5.97852l-3.83203,6.02148h2.86328l2.52148,-4.7168l2.5332,4.7168h2.82031l-3.76953,-6l3.68555,-6h-2.67578l-2.45508,4.50586l-2.32422,-4.50586zM32,26h15v8h-15zM32,36h15v7c0,0.55 -0.45,1 -1,1h-14z"></path></g></g>
                  </svg> -->
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256">
                    <g fill="#4f46e5" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M30,26v9h-4.18c0.12,-0.38 0.18,-0.78 0.18,-1.2v-7.8zM30,37v9h-13c-1.65,0 -3,-1.35 -3,-3v-5h7.8c1.03,0 1.98,-0.37 2.71,-1zM32,26h16v9h-16zM32,37h16v6c0,1.65 -1.35,3 -3,3h-13zM30,15v9h-4v-7.8c0,-0.42 -0.06,-0.82 -0.18,-1.2zM32,15h16v9h-16zM30,4v9h-5.49c-0.73,-0.63 -1.68,-1 -2.71,-1h-7.8v-5c0,-1.65 1.35,-3 3,-3zM48,7v6h-16v-9h13c1.65,0 3,1.35 3,3zM21.8,36h-17.6c-1.215,0 -2.2,-0.985 -2.2,-2.2v-17.6c0,-1.215 0.985,-2.2 2.2,-2.2h17.6c1.215,0 2.2,0.985 2.2,2.2v17.6c0,1.215 -0.985,2.2 -2.2,2.2zM7.968,19l3.494,5.978l-3.831,6.022h2.863l2.521,-4.716l2.533,4.716h2.821l-3.769,-6l3.685,-6h-2.675l-2.455,4.505l-2.323,-4.505z"></path></g></g>
                  </svg>
                </mat-icon>
              </button>
              <mat-menu #importMenu="matMenu">
                <button mat-menu-item (click)="downloadPriceListTemplate()">
                  <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
                  <span>Descargar Plantilla</span>
                </button>
                <input #my_file style="display: none" type="file" (change)="handleFileInput($event)" accept=".xlsx" #hiddenfileinput>
                <button mat-menu-item (click)="hiddenfileinput.click()">
                  <mat-icon svgIcon="heroicons_outline:arrow-up-tray"></mat-icon>
                  <span>Importar Archivo</span>
                </button>
              </mat-menu>
              <button mat-raised-button style="margin-right: 8px;" type="button" *ngIf="aux_file" [disabled]="this.fileToUpload.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" color="primary" (click)="onMessageConfirm()">
                Importar archivo
              </button>
            </div>
          </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" 
                matSort (matSortChange)="changeSort($event)">

                <!-- Producto -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Producto</th>
                    <td mat-cell *matCellDef="let element" class="text-sm uppercase leading-tight">
                        <div *ngIf="getCode(element) as code">
                          <b class="f-10">{{ code }}</b>
                        </div>
                        <span class="uppercase">{{ element.name }}</span>
                    </td>
                </ng-container>
    
                <!-- Lista de Precios-->
                <ng-container matColumnDef="price_list">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Lista de Precios</th>
                    <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                        <mat-icon color="primary" matBadge="{{element?.price_list?.count || 0}}" matBadgeColor="accent"
                            matBadgeSize="small" aria-hidden="false">local_atm
                        </mat-icon>
                        <mat-icon color="primary" style="margin-left: 10px;" matBadge="{{element?.liquidation_list?.count || 0}}" matBadgeColor="accent"
                            matBadgeSize="small" aria-hidden="false">money_off
                        </mat-icon>
                    </td>
                </ng-container>

                <!-- Lista Descuentos -->
                <ng-container matColumnDef="discount_list">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-10 text-left">Lista Descuentos</th>
                    <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                        <mat-icon color="primary" matBadge="{{element?.discount_list?.count || 0}}" matBadgeColor="accent"
                        matBadgeSize="small" aria-hidden="false">percent
                        </mat-icon>
                    </td>
                </ng-container>

                <!-- Lista Promociones -->
                <ng-container matColumnDef="promotions_list">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-10 text-left">Lista Promociones</th>
                    <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                        <mat-icon color="primary" matBadge="{{element?.promotions_list?.count || 0}}" matBadgeColor="accent"
                        matBadgeSize="small" aria-hidden="false">loyalty
                        </mat-icon>
                    </td>
                </ng-container>
    
                <!-- Acciones -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                    <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                        <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #actionMenu="matMenu">
                            <button mat-menu-item (click)="openEditModal(element)">
                                <mat-icon svgIcon="heroicons_outline:receipt-percent"></mat-icon>
                                <span>Conf. List. Descuentos</span>
                            </button>
                            <button mat-menu-item (click)="openModalSettingPriceList(element)">
                                <mat-icon svgIcon="heroicons_outline:credit-card"></mat-icon>
                                <span>Conf. List. Precios</span>
                            </button>
                            <button mat-menu-item (click)="openModalSettingPromotionList(element)">
                                <mat-icon svgIcon="heroicons_outline:tag"></mat-icon>
                                <span>Conf. List. Promociones</span>
                            </button>
                            <button mat-menu-item (click)="openDeleteDialog(element)">
                                <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                <span>Eliminar Registro</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>
    
                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
    
                <!-- Fila principal -->
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b h-16"></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
            <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
                [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
        </div>
      </div>
    </div>
  
      <!-- Modales -->
      <ng-template #addModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
        <mat-dialog-content class="modal-content">
          <form #createForm="ngForm">
            <div class="grid grid-cols-2 gap-4">
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Condición de Clase</mat-label>
                <mat-select [(ngModel)]="currentCreatePriceList.conditionClass" name="conditionClass" (selectionChange)="changeCondition()" required>
                  <mat-option *ngFor="let opcion of conditionClass" [value]="opcion.code">
                    {{ opcion.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Secuencia</mat-label>
                <mat-select [(ngModel)]="currentCreatePriceList.sequence" name="sequence" required>
                  <mat-option *ngFor="let sequence of sequenceListFilter" [value]="sequence.code">
                    {{ sequence.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Material</mat-label>
                <mat-select [(ngModel)]="currentCreatePriceList.field6" name="field6" required>
                  <mat-option>
                    <ngx-mat-select-search [(ngModel)]="searchMaterial" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="changueOptionsMaterial($event)" placeholderLabel="Buscar material..."
                        noEntriesFoundLabel="No se encontraron resultados">
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (item of materialList; track item) {
                  <mat-option [value]="item._id">
                    <b>{{ item.code }}</b> - {{ item.name }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="fill" class="w-full">
                <mat-label class="block text-gray-700">Desde/Hasta</mat-label>
                <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                  <input matStartDate formControlName="start" placeholder="Fecha Inicio">
                  <input matEndDate formControlName="end" placeholder="Fecha Fin">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>

              <!-- <mat-form-field class="w-full">
                <mat-label>Desde</mat-label>
                <input matInput [matDatepicker]="dateStart" [(ngModel)]="currentCreatePriceList.dateStart" name="dateStart" required>
                <mat-datepicker-toggle matIconSuffix [for]="dateStart"></mat-datepicker-toggle>
                <mat-datepicker #dateStart></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="w-full">
                  <mat-label>Hasta</mat-label>
                  <input matInput [matDatepicker]="dateEnd" [(ngModel)]="currentCreatePriceList.dateEnd" name="dateEnd" required>
                  <mat-datepicker-toggle matIconSuffix [for]="dateEnd"></mat-datepicker-toggle>
                  <mat-datepicker #dateEnd></mat-datepicker>
              </mat-form-field> -->

            </div>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button mat-raised-button color="primary" (click)="createMaterialPriceList()"
            [disabled]="!createForm.valid">Guardar</button>
        </mat-dialog-actions>
      </ng-template>
  
      <!-- <ng-template #editModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro:</h2>
        <mat-dialog-content class="modal-content">
          
          <form #editForm="ngForm">
            <mat-form-field appearance="fill" class="modal-input">
              <mat-label>Código</mat-label>
              <input matInput [(ngModel)]="currentUpdatePriceList.code" name="code" required>
            </mat-form-field>
            <mat-form-field appearance="fill" class="modal-input">
              <mat-label>Nombre</mat-label>
              <input matInput [(ngModel)]="currentUpdatePriceList.name" name="name" required>
            </mat-form-field>
            <mat-form-field appearance="fill" class="modal-input">
                <mat-label>Selecciona un tipo</mat-label>
                <mat-select
                  [(ngModel)]="currentUpdatePriceList.type"
                  name="type"
                  required
                >
                <mat-option *ngFor="let type of typeList" [value]="type.valor">{{ type.label }}</mat-option>
                </mat-select>
              </mat-form-field>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button mat-raised-button color="primary" [mat-dialog-close]="true" [disabled]="!editForm.valid">Guardar</button>
        </mat-dialog-actions>
      </ng-template>--->
  
      <ng-template #deleteDialog let-data>
        <div class="flex items-start space-x-2 mb-4">
          <div class="flex items-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
              style="font-size: 32px;"></mat-icon>
          </div>
          <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
            <mat-dialog-content class="modal-content mt-0">
              <p>¿Está seguro que desea eliminar el registro?</p>
            </mat-dialog-content>
          </div>
        </div>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Conservar</button>
          <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
        </mat-dialog-actions>
      </ng-template>
  </div>

  <app-filter>
    <app-no-filters-available></app-no-filters-available>
  </app-filter>
</mat-sidenav-container>